{
  "de": {
    "models": {
      "image": {
        "background": "Als Hintergrund verwenden?",
        "enabled": "Aktiviert?",
        "global": "Global?",
        "delete": "Löschen",
        "start": "Starten",
        "cancel": "Abbrechen",
        "processing": "Verarbeitung...",
        "error": "Fehler",
        "name": "Name",
        "size": "Dateigröße",
        "dropzone": "Bilder hier ablegen"
      }
    }
  }
}
